import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import useReveal from "@/hooks/useReveal";

const TEXTURE_URL =
  "https://static.prod-images.emergentagent.com/jobs/191a8ee3-3432-4ba7-9a47-86bd3d7ed9e3/images/133f979bc6abe8fbb065b795017303c97dcce47a40283d6a73d23e03d5907c69.png";

export default function FooterCTA() {
  const ref = useReveal();

  return (
    <section
      data-testid="footer-cta-section"
      className="relative overflow-hidden bg-[#082933] text-[#F4F3EE]"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-20 mix-blend-screen"
        style={{
          backgroundImage: `url(${TEXTURE_URL})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="gp-grain" aria-hidden />

      <div className="relative gp-container py-28 md:py-40">
        <div ref={ref} className="reveal grid grid-cols-12 gap-y-10 md:gap-x-12 items-end">
          <div className="col-span-12 lg:col-span-8">
            <span className="gp-overline" style={{ color: "#E88B46" }}>
              // Claim your time back
            </span>
            <h2
              data-testid="footer-cta-text"
              className="mt-6 font-display text-4xl sm:text-6xl lg:text-7xl font-semibold leading-[1.02] tracking-tight"
            >
              Ditch the spreadsheets.{" "}
              <span className="italic text-[#E88B46]">Claim your time back.</span>
            </h2>
            <p className="mt-8 max-w-2xl text-lg text-[#F4F3EE]/85 leading-relaxed">
              Sign up, enter your wells, run your first payout — all
              self-serve, all in one afternoon. No installation, no six-figure
              setup fees, no contracts, no phone calls.
            </p>
          </div>

          <div className="col-span-12 lg:col-span-4 lg:justify-self-end w-full">
            <div className="border-t border-[#F4F3EE]/20 pt-8 lg:border-none lg:pt-0 flex flex-col gap-4">
              <Link
                to="/pricing"
                data-testid="footer-cta-button"
                className="gp-btn gp-btn-accent w-full sm:w-auto"
              >
                Get Started Today
                <ArrowUpRight size={16} />
              </Link>
              <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#F4F3EE]/65">
                Instant · self-serve · cancel anytime
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
